import React from 'react';
import styles from './index.module.less';
import type { IDropdownMenuItem } from '../../common';
import { HeaderContext } from '../../common';
import { ReoIcon } from '@reolink-web/components.basic';
import classNames from 'classnames';

interface IDropdownSubMenuProps {
    menus: Array<Omit<IDropdownMenuItem, 'children'>>;
    title: string;
    isShowSubMenu?: boolean;
    onShowSubMenuClick?: () => void;
}

const CompDropItemWithSubMenu: React.FC<IDropdownSubMenuProps> = (props) => {
    const { getTextByKey } = React.useContext(HeaderContext);

    return (
        <li
            className={ classNames(styles['dropdown-menu-item'], {
                [styles['dropdown-menu-item-show-sub']]: props.isShowSubMenu,
            }) }
        >
            <span
                className={ styles['dropdown-menu-item-link'] }
                // eslint-disable-next-line react/jsx-handler-names
                onClick={ props.onShowSubMenuClick }
            >
                <span>{props.title}</span>
                {props.menus?.length ? (
                    <ReoIcon
                        name={ props.isShowSubMenu ? 'icon-icon_cross2' : 'icon-icon_plus' }
                        className={ styles['dropdown-menu-item-icon'] }
                    />
                ) : null}
            </span>
            <ul className={ classNames(styles['dropdown-sub-menu-content']) }>
                {props.menus.map((item) => {
                    return (
                        <li
                            className={ styles['dropdown-sub-menu-item'] }
                            key={ item.title }
                            // eslint-disable-next-line react/jsx-handler-names
                            onClick={ item.onClick }
                        >
                            <a
                                className={ styles['dropdown-sub-menu-item-link'] }
                                href={ item.link }
                                target="_blank"
                                rel="noreferrer"
                            >
                                {getTextByKey(item.title)}
                            </a>
                        </li>
                    );
                })}
            </ul>
        </li>
    );
};
export default CompDropItemWithSubMenu;
